import VN from "../components/VN";
import { useContext, useState } from "react";
import { UserDataContext } from "../components/UserDataContext";
import { Navigate } from "react-router-dom";
import {
  Button,
  Typography,
  Container,
  Box,
  Paper,
  Divider,
  Collapse,
} from "@mui/material";

import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import VolunteerActivismIcon from "@mui/icons-material/VolunteerActivism";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import NurseAdd from "./NurseAdd";
import ListAdmin from "./List-admin";

export default function Menu() {
  const { userData } = useContext(UserDataContext);
  const [activeForm, setActiveForm] = useState(null);
  const handleToggleForm = (formName) => {
    setActiveForm((prev) => (prev === formName ? null : formName));
  };

  console.log("userData in Admin.js: ", userData);

  if (Number(userData?.group) !== 9) {
    return <Navigate to="/nopermission" replace />;
  }

  return (
    <Box sx={{ backgroundColor: "#f8fafc", minHeight: "100vh", pb: 6 }}>
      <VN userData={userData} />

      <Container maxWidth="lg" sx={{ mt: 4 }}>
        <Paper
          elevation={0}
          sx={{
            p: 4,
            borderRadius: "16px",
            border: "1px solid #e2e8f0",
            boxShadow: "0 10px 30px rgba(0, 0, 0, 0.04)",
            backgroundColor: "#ffffff",
          }}
        >
          {/* NAGŁÓWEK PANELU */}
          <Box sx={{ mb: 3 }}>
            <Typography
              variant="h4"
              component="h1"
              sx={{
                fontWeight: 700,
                color: "#1e293b",
                letterSpacing: "-0.5px",
                mb: 1,
              }}
            >
              Panel Administratora
            </Typography>
            <Typography variant="body1" sx={{ color: "#64748b" }}>
              Zarządzaj strukturą opiekunek i pielęgniarek w serwisie.
            </Typography>
          </Box>

          <Divider sx={{ mb: 4 }} />

          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              gap: 2,
              justifyContent: "flex-start",
              alignItems: "stretch",
            }}
          >
            <Button
              variant="contained"
              startIcon={<AssignmentIndIcon />}
              onClick={() => handleToggleForm("unverified-list")}
              sx={{
                flex: 1,
                py: 1.5,
                px: 3,
                fontWeight: 600,
                fontSize: "0.95rem",
                borderRadius: "10px",
                textTransform: "none",
                backgroundColor:
                  activeForm === "unverified-list" ? "#0d1b60" : "#1a237e",
                boxShadow: "0 4px 12px rgba(26, 35, 126, 0.2)",
                "&:hover": {
                  backgroundColor: "#0d1b60",
                  boxShadow: "0 6px 16px rgba(26, 35, 126, 0.3)",
                },
              }}
            >
              Lista niezweryfikowanych opiekunek
            </Button>
            <Button
              variant="contained"
              startIcon={<LocalHospitalIcon />}
              onClick={() => handleToggleForm("nurse-add")}
              sx={{
                flex: 1,
                py: 1.5,
                px: 3,
                fontWeight: 600,
                fontSize: "0.95rem",
                borderRadius: "10px",
                textTransform: "none",
                backgroundColor:
                  activeForm === "nurse-add" ? "#0d1b60" : "#1a237e",
                boxShadow: "0 4px 12px rgba(26, 35, 126, 0.2)",
                "&:hover": {
                  backgroundColor: "#0d1b60",
                  boxShadow: "0 6px 16px rgba(26, 35, 126, 0.3)",
                },
              }}
            >
              Dopisanie osoby weryfikującej
            </Button>

            <Button
              variant="contained"
              startIcon={<VolunteerActivismIcon />}
              onClick={() => handleToggleForm("caregiver-add")}
              sx={{
                flex: 1,
                py: 1.5,
                px: 3,
                fontWeight: 600,
                fontSize: "0.95rem",
                borderRadius: "10px",
                textTransform: "none",
                backgroundColor:
                  activeForm === "caregiver-add" ? "#0d1b60" : "#1a237e",
                boxShadow: "0 4px 12px rgba(26, 35, 126, 0.2)",
                "&:hover": {
                  backgroundColor: "#0d1b60",
                  boxShadow: "0 6px 16px rgba(26, 35, 126, 0.3)",
                },
              }}
            >
              Dopisanie opiekunki
            </Button>

            <Button
              variant="contained"
              startIcon={<AssignmentIndIcon />}
              onClick={() => handleToggleForm("assign-caregiver")}
              sx={{
                flex: 1,
                py: 1.5,
                px: 3,
                fontWeight: 600,
                fontSize: "0.95rem",
                borderRadius: "10px",
                textTransform: "none",
                backgroundColor:
                  activeForm === "assign-caregiver" ? "#0d1b60" : "#1a237e",
                boxShadow: "0 4px 12px rgba(26, 35, 126, 0.2)",
                "&:hover": {
                  backgroundColor: "#0d1b60",
                  boxShadow: "0 6px 16px rgba(26, 35, 126, 0.3)",
                },
              }}
            >
              Przypisanie opiekunki do pielęgniarki
            </Button>
          </Box>

          <Collapse in={Boolean(activeForm)} timeout="auto" unmountOnExit>
            <Box sx={{ mt: 4, pt: 3, borderTop: "1px dashed #cbd5e1" }}>
              {activeForm === "nurse-add" && (
                <Box>
                  <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
                    Formularz dodawania osoby weryfikującej
                  </Typography>

                  <NurseAdd onSuccess={() => setActiveForm(null)} />
                </Box>
              )}

              {activeForm === "caregiver-add" && (
                <Typography>
                  Formularz dopisania opiekunki (w trakcie wdrażania)
                </Typography>
              )}

              {activeForm === "assign-caregiver" && (
                <Typography>
                  Formularz przypisania (w trakcie wdrażania)
                </Typography>
              )}

              {activeForm === "unverified-list" && (
                <Box>
                  <Typography>
                    Lista niezweryfikowanych opiekunek (w trakcie wdrażania)
                  </Typography>
                  <ListAdmin onSuccess={() => setActiveForm(null)} />
                </Box>
              )}
            </Box>
          </Collapse>
        </Paper>
      </Container>
    </Box>
  );
}
